import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import Global from '../store/global-selectors';
import { getFeatureDisplayForPlan } from './feature-gate-display-mode';
import { isNewLineupPlanPorfileAndBillingPlan } from './feature-gate-helper';

export const DefaultGatedDisplayMode = { shouldHide: false };

/** @typedef {import('../constants/features-type').FeatureCode} FeatureCode */

/**
 * Determines if we `shouldHide` the feature based on the seller's subscription plan. If false, we should show the feature in the 'locked' state
 * @param {FeatureCode} feature
 * @returns {{ shouldHide: boolean }}
 */
export const usePlanFeatureDisplayMode = (feature) => {
  const { planProfileId, billingPlanId } = useSelector(Global.selectSellerSubscriptionPlanInfo) || {};

  return useMemo(() => {
    const isPlanProfileNewLineUp = isNewLineupPlanPorfileAndBillingPlan(planProfileId, billingPlanId);
    if (!isPlanProfileNewLineUp) {
      return DefaultGatedDisplayMode;
    }

    const { hidden } = getFeatureDisplayForPlan(billingPlanId);
    const shouldHide = hidden?.includes(feature) || false;
    return { shouldHide };
  }, [billingPlanId, feature, planProfileId]);
};
